import { useMutation } from '@tanstack/react-query';

import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { ApiErrorResponse } from '../../../types';
import { voidEnvelope } from '../../requests/voidEnvelope';

type VoidEnvelopeVariables = {
  envelopeId: string;
  data: Record<string, any>;
};

export const useVoidEnvelope = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<
    unknown,
    Error,
    VoidEnvelopeVariables
  >({
    mutationFn: ({ envelopeId, data }) =>
      voidEnvelope(constructPost, envelopeId, data),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Failed to void contract.')),
    onSuccess: () => handleSuccess('Contract voided'),
  });

  return { voidEnvelope: mutateAsync, ...rest };
};
